import React from 'react';
import { translate } from 'core/utils';
import { BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const StatusChangeTemplate = ({
	t,
	statusChangeViewStore: {
		form,
		fulfillmentOrderStatusOptions,
		returnReasonOptions,
		selectedReturnReason,
		selectedFulfillmentOrderStatus,
		onChange,
		disableSaveBtn,
		showReturnOptions
	},
}) => {
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('STATUSCHANGEVIEW.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="inputgroup spc--bottom--sml">
						<BaasicSelect
							field={form.$('fulfillmentOrderStatusId')}
							clearable={false}
							options={fulfillmentOrderStatusOptions.slice()}
							onChange={onChange}
							value={selectedFulfillmentOrderStatus}
						/>
					</div>
					{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={disableSaveBtn}>
						{t('SAVE')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(StatusChangeTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/StatusChangeTemplate.jsx